import { TextField } from '@mui/material';
import type { FieldRendererProps } from '../types';

export function NumberInput({ name, label, required, value, error, onChange }: FieldRendererProps) {
  return (
    <TextField
      name={name}
      label={label}
      required={required}
      type="number"
      inputProps={{ inputMode: 'decimal' }}
      value={value === null || value === undefined ? '' : String(value)}
      onChange={(e) => {
        const raw = e.target.value;
        if (raw === '') onChange(null);
        else {
          const parsed = Number(raw);
          onChange(Number.isFinite(parsed) ? parsed : raw);
        }
      }}
      error={!!error}
      helperText={error ?? undefined}
    />
  );
}
